import { Directive, ElementRef, HostListener, Input, Renderer2 } from '@angular/core';
import { AppState } from '../../config/state';
import { EventsProvider } from '../../providers/events/events';
import moment from 'moment';
/**
 * Generated class for the CoEventImageFallbackDirective directive.
 *
 * See https://angular.io/api/core/Directive for more info on Angular
 * Directives.
 */
@Directive({
  selector: '[co-event-image-fallback]' // Attribute selector
})
export class CoEventImageFallbackDirective {
  element: any;
  eventTypes: any;
  @Input() event: any;
  constructor(private el: ElementRef, private state: AppState, private Render: Renderer2, private events: EventsProvider) {
    this.element = el;
  }

  ngOnInit(): void {
    if(!this.state.eventColors || !this.state.eventColors.types) {
      this.events.getEventTypes().then( types => {
        this.eventTypes = types;
        this.init();
      });
    }
    else {
      this.eventTypes = this.state.eventColors.types;
      this.init();
    }
  }

  init() {
    this.getEventImage().then(img => {
      this.el.nativeElement.innerHTML = img;
    })
  }

  async getEventImage() {
    let eventTypeObject;
    if (this.event.types) {
      eventTypeObject = this.eventTypes.find(object => object.name === this.event.types[0]);
    }
    if (this.event.eventImage) {
      return `<div class="imageContain" ><img no-padding src="https://${this.state.client.keyword}.libnet.info/images/events/${this.state.client.keyword}/${this.event.eventImage}" ></div>`
    } else if (eventTypeObject && eventTypeObject.image !== null) {
      return `<div class="imageContain" ><img no-padding src="https://${this.state.client.keyword}.libnet.info/images/events/${this.state.client.keyword}/${eventTypeObject.image}" ></div>`;
    } else {
      try {
        let icon = this.state.eventColors.types.filter(e => {
          return e.name === this.event.types[0]
        });
        return `
        <div style="border:2px solid ${icon[0].color};" class="iconContain">
          <div style="height:33%;background-color:${icon[0].color};text-transform:uppercase;color:#fff;display:flex;align-items:center;justify-content:center;">
            <div style="font-weight:700;font-size:1.5em">${moment(this.event.eventStart).format('MMM')}</div>
          </div>
          <div style="text-align:center;font-size:2em;font-weight:300;display:flex;align-items:center;justify-content:center;height:66%;">
            <div style="vertical-align:middle;font-weight:700;font-size:2em">${moment(this.event.eventStart).format('DD')}</div>
          </div>
        </div>
        `
      } catch (ex) {
        return `
        <div style="border:2px solid gray;" class="iconContain">
          <div style="height:33%;background-color:gray;text-transform:uppercase;color:#fff;display:flex;align-items:center;justify-content:center;">
            <div style="font-weight:700;font-size:1.5em">${moment(this.event.eventStart).format('MMM')}</div>
          </div>
          <div style="text-align:center;font-size:2em;font-weight:300;display:flex;align-items:center;justify-content:center;height:66%;">
            <div style="vertical-align:middle;font-weight:700;font-size:2em">${moment(this.event.eventStart).format('DD')}</div>
          </div>
        </div>
        `;
      }
    }
  };


}



// WEBPACK FOOTER //
// ./src/directives/co-event-image-fallback/co-event-image-fallback.ts